import z from 'zod'
import { LanguageValidation } from '../../../../../../shared/domain/Language'
import { MarketValidation } from '../../../../../../shared/domain/Market'
import type { GETBannerInformationResponseLenient as GETBannerInformationResponseLenientType } from '../../banners/banners-json'
import { GETBannerInformationResponseLenient } from '../../banners/banners-json'

export const GETActiveBannersMarketingQuery = z.object({
  language: LanguageValidation.shape.value,
  market: MarketValidation.shape.value,
})

export type GETActiveBannersMarketingQueryType = z.infer<typeof GETActiveBannersMarketingQuery>

export const GETActiveBannersMarketingResponse = GETBannerInformationResponseLenient

export type GETActiveBannersMarketingResponseType = GETBannerInformationResponseLenientType
